import ChatIcon from '@mui/icons-material/Sms';

import { useIntercom } from '@zenbusiness/application-commons-intercom';
import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import ResponsiveButton from '../ResponsiveButton';

export default function ChatButton() {
  const { showNewMessage } = useIntercom();

  return (
    <ResponsiveButton
      data-testid="intercom-button"
      icon={<ChatIcon />}
      onClick={() => showNewMessage()}
    >
      <FormattedMessage id="shopping.header.chat" />
    </ResponsiveButton>
  );
}
